// Moves a single workout in/out of a workout folder by updating the
// folders' `workoutIds` arrays (folder membership has no field on the
// workout/cycle document itself).
const assignWorkoutToFolder = async ({ api, coachId, workoutId, folderId }) => {
  if (!workoutId) return;

  const foldersRes = await api("workout-folders", { query: { coachId } });
  const folders = foldersRes.ok
    ? ((await foldersRes.json())?.folders ?? [])
    : [];

  const currentFolder = folders.find((f) =>
    (f.workoutIds || []).some((id) => String(id) === String(workoutId))
  );

  if (currentFolder && String(currentFolder._id) !== String(folderId || "")) {
    const nextIds = (currentFolder.workoutIds || []).filter(
      (id) => String(id) !== String(workoutId)
    );
    await api(`workout-folders/${currentFolder._id}`, {
      method: "PUT",
      body: { workoutIds: nextIds, coachId },
    });
  }

  if (folderId) {
    const target = folders.find((f) => String(f._id) === String(folderId));
    if (target) {
      const alreadyIn = (target.workoutIds || []).some(
        (id) => String(id) === String(workoutId)
      );
      if (!alreadyIn) {
        await api(`workout-folders/${folderId}`, {
          method: "PUT",
          body: {
            workoutIds: [...(target.workoutIds || []), workoutId],
            coachId,
          },
        });
      }
    }
  }
};

export default assignWorkoutToFolder;
